<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col">

          <h1 class="title text-center pt-4">Contact us</h1>
          <!-- <h2 class="muted text-center pb-4">resolute.partners UK</h2> -->

          <p class="regular">Message us:</p>
          <h3><a href="mailto: hello@resolute.partners">hello@resolute.partners</a></h3>

          <hr class="space space-xs">

          <p class="regular">Talk:</p>
          <h4 class="no-margin"><a href="tel:+44 3333 444906">+44 3333 444906</a></h4>
          <p class="no-margin smaller muted">Please leave a message outside of working hours.</p>

          <hr class="space space-xs">

          <p class="regular">London:</p>
          <h4><a href="https://goo.gl/maps/E2NwnuV1BFTcc8pB8">45-47 Clerkenwell Green, London, EC1R 0EB, UK</a></h4>

          <hr class="space space-xs">

          <p class="regular">Brighton &amp; Hove:</p>
          <h4><a href="https://goo.gl/maps/67XD5Lvi73Y3bkcm7">Hove Town Hall, Church Road, Hove BN3 2AF, UK</a></h4>

          <hr class="space space-xs">

          <p class="regular">Lisbon:</p>
          <h4><a href="https://goo.gl/maps/RWrqUiknUCkFbm1SA">Mercado da Ribeira, Avenida 24 de Julho 1200-479 Lisboa, Portugal</a></h4>

          <hr class="space space-xs">

          <p class="regular">Los Angeles:</p>
          <h4><a href="https://goo.gl/maps/RWrqUiknUCkFbm1SA">1370 N St. Andrew's Place, Los Angeles, CA, 90028</a></h4>

          <hr class="space space-sm">

          <div class="text-center">
          <p>In a hurry?</p>
          <a href="#" class="btn btn-outline-primary" @click.prevent="openChat()">
              Chat to us now
          </a>
          </div>

          <hr class="space space-sm">
          <hr class="py-4">

          <!-- <div class="row">
            <div class="col col-md-8 offset-md-2 text-center">
              <p>
                Just looking for a quote?
              </p>
              <router-link class="btn btn-outline-primary" :to="{ name: 'request-proposal' }">Request proposal</router-link>
              <hr class="space space-sm">
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <hr class="divider">
  </div>
</template>

<script>

export default {
  name: 'contact',
  data () {
    return {
    }
  },
  methods: {
    openChat () {
      window.customerly.open()
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
